import {
  ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {NewsService} from "../shared/news.service";
import {News} from "../../+news/news.model";

declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'admin-app-news',
  styles: [ require('./news.component.css') ],
  template: require('./news.component.html')
})
export class NewsComponent implements OnInit {

  isBrowser: boolean;
  news: News[];
  currentNews: News;
  files: FileList;

  @ViewChild("newsModalDiv") newsModalDiv: ElementRef;

  constructor(private newsService: NewsService, @Inject('isBrowser') isBrowser){
    this.isBrowser = isBrowser;
  }

  ngOnInit(): void {
    if(this.isBrowser){
      this.getNews();
    }
  }

  getNews(){
    this.newsService.getNews().subscribe(news => this.news = news);
  }

  deleteNews(id: string){
    this.newsService.deleteNews(id)
      .subscribe(()=>{
        this.getNews();
      });
  }

  onSelect(news: News){
    this.newsService.getNewsById(news['_id'])
      .subscribe(news => {
        this.currentNews = news;
        this.openModal();
      });
  }

  openCreateNewsModal(){
    this.currentNews = {
      category: "",
      date: null,
      title: null,
      text: null,
      image: null
    };
    this.openModal();
  }

  //open modal dialog
  openModal(){
    $(this.newsModalDiv.nativeElement).modal('show');
  }

  //close modal dialog
  closeModal(){
    $(this.newsModalDiv.nativeElement).modal('hide');
  }

  createNews(){
    this.newsService.createNews(this.currentNews)
      .flatMap(res => {
        this.currentNews["_id"] = res["_id"];
        return this.newsService.uploadImages(this.currentNews["_id"],this.files);
      })
      .subscribe(res => {
        this.closeModal();
        this.getNews();
      });

  }

  updateNews(){
    this.newsService.updateNews(this.currentNews)
      .flatMap(res => {
        return this.newsService.uploadImages(this.currentNews["_id"],this.files);
      })
      .subscribe(res => {
        this.closeModal();
        this.getNews();
      });

  }

  onFileChange(event){
    let fileList: FileList = event.target.files;
    this.files = fileList;
  }

  save(){
    if(this.currentNews["_id"] != null){
      this.updateNews();
    } else {
      this.createNews();
    }

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/+news/news.component.ts